// EXCLUDED FROM PERSIST-GATE
const initialState = {
    leads: {
        CONTACT: [],
        TALKING: [],
        OFFER: [],
        NOT_NOW: [],
        ORDER: [],
        INVOICE: [],
        DECLINED_BY_CLIENT: [],
        DECLINED_BY_AGENT: []
    },
    columns: [
        {key: "PROSPECTARE", label: "Prospectare", index: 0},
        {key: "CONTACT", label: "Agenda lucru", index: 1},
        {key: "OFERTA", label: "Oferte", index: 2},
        {key: "NU_ACUM", label: "Nu acum", index: 3},
        {key: "COMANDA", label: "Comenzi", index: 4},
        {key: "FACTURA", label: "Facturi", index: 5},
        // {key: "TRANSFERAT_MULTIDOM",label: "Trimis catre Multidom", index: 6}, 
        {key: "REFUZ_CLIENT", label: "Refuz client", index: 6}
    ],
    visibleColumns: [
        // {key: "PROSPECTARE", label: "Prospectare", index: 0},
        {key: "CONTACT", label: "Agenda lucru", index: 1},
        {key: "OFERTA", label: "Oferte", index: 2},
        {key: "NU_ACUM", label: "Nu acum", index: 3},
        {key: "COMANDA", label: "Comenzi", index: 4},
        // {key: "FACTURA", label: "Facturi", index: 5},
        // {key: "TRANSFERAT_MULTIDOM",label: "Trimis catre Multidom", index: 6}, 
        // {key: "REFUZ_CLIENT", label: "Refuz client", index: 7}
    ],
}

export const SET_LEADS = "LEADS_OPTIONS/SET_PAGE_LOADING";
export const SET_VISIBLE_COLUMNS = "LEADS_OPTIONS/SET_VISIBLE_COLUMNS";

export const setLeads = (leads, status) => ({
    type: SET_LEADS,
    leads,
    status
})

export const setVisibleColumns = (columns) => ({
    type: SET_VISIBLE_COLUMNS,
    columns
})

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_LEADS: {
            return {
                ...state,
                leads: {...state.leads, [action.status]: action.leads}
            }
        }
        case SET_VISIBLE_COLUMNS: {
            return {
                ...state,
                visibleColumns: action.columns
            }
        }
        default:
            return state;
    }
}